// extracted by mini-css-extract-plugin
export default {"root":"LoadingWrapper_root__kB9SN"};